import { fundAccountTypes, apiFieldMappingsVendorPayouts } from 'x/modules';
import { Settings } from 'x/views';

export const learnMoreLink = 'https://razorpay.com/x';

export const apiFieldMappings = {
  ...apiFieldMappingsVendorPayouts,
  notesToMerchant: 'notes_to_merchant',
  fundAccountId: 'fund_account_id',
};

export const defaultTdsCategoryId = 8;

export const vendorPortalInvoiceStatusTypes = {
  accepted: 'accepted',
  processing: 'processing',
  paid: 'paid',
  rejected: 'rejected',
  partiallyPaid: 'partially_paid',
  scheduled: 'scheduled',
  sentToMerchant: 'sent_to_merchant',
};

export const vendorPortalMerchantIdsMap = {
  beta: 'IROVmOdbuu3A7o',
  devstack: 'IROVmOdbuu3A7o',
  func: 'IPO8huBg4xMQsP',
  prod: 'IZzuoZNheTtZzZ',
};

export const mandatoryFieldsForInvoiceCreation = [
  'invoiceNumber',
  'totalAmount',
  'payoutAmount',
  'dueDate',
  'invoiceIssueDate',
];

export const tdsPercentageFieldName = 'tdsPercentage';

export const payoutAmountFieldName = 'payoutAmount';

export const notesToMerchantFieldName = 'notesToMerchant';

export const emptyErrorMessage = 'Please fill this field';

export const vendorPreferencesApiMapping = {
  businessName: 'business_name',
  name: 'name',
  contact: 'contact',
  gstin: 'gstin',
  pan: 'pan',
  tdsCategoryId: 'tds_category',
  paymentTerms: 'payment_terms',
  fundAccount: 'fund_account',
  accountType: 'account_type',
  bankAccount: 'bank_account',
  bankName: 'bank_name',
  accountNumber: 'account_number',
  address: 'address',
};

export const mandatoryFieldsForVendorPreferences = {
  personal: ['name', 'contact'],
  business: ['tdsCategoryId'],
  banking: {
    [fundAccountTypes.bankAccount]: ['name', 'accountNumber', 'ifsc'],
    [fundAccountTypes.vpa]: ['vpa'],
  },
};

export const vendorPortalTourTypes = {
  NO_TOUR: 'NO_TOUR',
  CREATE_INVOICE_TOUR: 'CREATE_INVOICE_TOUR',
  EXISTING_INVOICE_TOUR: 'EXISTING_INVOICE_TOUR',
};

type VendorPortalSettings = Record<string, keyof Settings>;

export const SETTINGS_KEYS: VendorPortalSettings = {
  skipVendorPortalTour: 'skip_vendor_portal_tour',
  skipVendorPortalInvoiceCreationFeedback: 'skip_vendor_portal_invoice_creation_feedback',
};

export const fundAccountTypeOptions = [
  {
    key: fundAccountTypes.bankAccount,
    logo: '/dist/assets/img/icons/netbanking.svg',
    title: 'Bank A/C',
  },
  {
    key: fundAccountTypes.vpa,
    logo: '/dist/assets/img/icons/upi.svg',
    title: 'UPI ID',
  },
];

export const vendorPreferencesSteps = {
  PERSONAL: 0,
  BUSINESS: 1,
  BANKING: 2,
  COMPLETE: 3,
} as const;
